import { reducer } from './reducer';

const sessionModule = () => ({
  id: 'Session',
  reducerMap: {
    Session: reducer,
  },
  initialActions: [],
  finalActions: [],
});

export { sessionModule };
